const PATHS = {
  homepage: '/',
  videoIds: '/video/:id',
  about: '/about',
  form: '/forms',
  page404: '*',
};

const APIKEY = 'AIzaSyCwmPlVgLaoTpX0sq3vqEi-I2Cl3sBqCHw';
const MOSTPOPULARLINK = `https://youtube.googleapis.com/youtube/v3/videos?part=snippet&part=statistics&chart=mostPopular&key=${APIKEY}`;
const SEARCHLINK = `https://youtube.googleapis.com/youtube/v3/search?part=snippet&key=${APIKEY}`;
const SINGLEVIDEO = `https://youtube.googleapis.com/youtube/v3/videos?part=snippet&part=statistics&key=${APIKEY}&id=`;
export { PATHS, APIKEY, MOSTPOPULARLINK, SEARCHLINK, SINGLEVIDEO };
